import { render, staticRenderFns } from "./crudWhatsapp.vue?vue&type=template&id=1de08bb1"
import script from "./crudWhatsapp.vue?vue&type=script&lang=js"
export * from "./crudWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports